var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 0 0-8 8c0 4.01 2.955 7.323 6.804 7.901V10.12h-1.98V8.017h1.98V6.618c0-2.317 1.129-3.333 3.054-3.333.922 0 1.41.068 1.64.099v1.835h-1.313c-.817 0-1.102.776-1.102 1.649v1.15h2.395l-.325 2.102h-2.07v5.798C12.987 15.388 16 12.05 16 8a8 8 0 0 0-8-8"
  })));
};
export default SvgFacebook;